import gql from 'graphql-tag';
import { Coupon } from '../types/generalTypes';
import { ProductNode } from '../types/productTypes';
import { VARIABLE_PRODUCT_FIELDS } from './archive';

export interface CartNode {
  [key: string]: any;
  key: string;
  quantity: number;
  variation: {
    [key: string]: any;
    node: {
      id: string;
      sku: string;
      onSale: boolean;
      salePrice: string;
      regularPrice: string;
      stockQuantity: number;
      image: {
        srcSet: string;
        mediaItemUrl: string;
      };
      attributes: {
        nodes: [
          {
            id: string;
            name: string;
            value: string;
          },
          {
            id: string;
            name: string;
            value: string;
          }
        ];
      };
    };
  };
  product: ProductNode;
}

export interface GetCartResponse {
  cart: {
    isEmpty: boolean;
    subtotal?: string;
    total: string;
    discountTotal: string;
    shippingTotal: string;
    chosenShippingMethods?: string[];
    chosenShippingMethod?: string;
    totalWithoutShipping: string;
    appliedCoupons: {
      code: string;
      discountAmount?: string;
      description?: string;
    }[] | null;
    contents: {
      itemCount: number;
      nodes: CartNode[];
    };
  };
}

export const normalizeAppliedCoupons = (coupons?: unknown): Coupon[] => {
  if (!Array.isArray(coupons)) {
    return [];
  }

  return coupons.map((coupon: any) => ({
    id: coupon.id || coupon.code,
    code: coupon.code,
    amount: coupon.amount ?? coupon.discountAmount ?? "",
    discountType: coupon.discountType || "",
  }));
};

export const getChosenShippingMethod = (
  cart?: {
    chosenShippingMethods?: string[] | null;
    chosenShippingMethod?: string | null;
  } | null
) => {
  if (cart?.chosenShippingMethods && cart.chosenShippingMethods.length) {
    return cart.chosenShippingMethods[0];
  }
  return cart?.chosenShippingMethod || "";
};

export const getCart = gql`
  query getCart {
    cart {
      isEmpty
      subtotal
      total
      discountTotal
      shippingTotal
      chosenShippingMethods
      appliedCoupons {
        code
        discountAmount
        description
      }
      contents(first: 1000) {
        itemCount
        nodes {
          key
          quantity
          variation {
            node {
              id
              sku
              onSale
              salePrice
              regularPrice
              stockQuantity
              image {
                mediaItemUrl
                srcSet(size: LARGE)
              }
              attributes {
                nodes {
                  id
                  name
                  value
                }
              }
            }
          }
          product {
            node {
              id
              slug
              databaseId
              name
              onSale
              type
              image {
                id
                mediaItemUrl
                srcSet(size: LARGE)
              }
              productBrands {
                nodes {
                  id
                  name
                  slug
                }
              }
              productCategories {
                nodes {
                  id
                  slug
                  name
                  databaseId
                }
              }

              ... on SimpleProduct {
                id
                name
                salePrice
                regularPrice
                stockQuantity
                stockStatus
                localAttributes {
                  nodes {
                    name
                    options
                    id
                  }
                }
              }
              ... on VariableProduct {
                ...VariableProductFields
              }
            }
          }
        }
      }
    }
  }
  ${VARIABLE_PRODUCT_FIELDS}
`;
